export const exhibitionDefaultAttribute = "data-js-exhibition";
